import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../../util/reactIntl';

import SectionContainer from '../SectionContainer';

import mapIcon from '../../../../assets/icon-map.svg';
import calendarIcon from '../../../../assets/icon-calendar.svg';
import locationIcon from '../../../../assets/icon-location.svg';

import css from './Cta.module.css';

/**
 * Code-only landing CTA section (inserted after hero in LandingPage).
 * Replace copy, links, and styles as needed.
 *
 * @component
 * @param {Object} props
 * @param {string} props.sectionId
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 * @param {Object} props.defaultClasses
 * @param {Object?} props.appearance
 * @param {Object?} props.options
 */

const content = [
  {
    icon: locationIcon,
    title: 'Find Gear Near You',
    description:
      'Browse outdoor gear shared by people in your area — ready when you are.',
    buttonText: 'Browse Gear',
    buttonLink: '/listings',
  },
  {
    icon: calendarIcon,
    title: 'Book It Easily',
    description:
      'Reserve your dates, message the owner, and pay securely in just a few clicks.',
    buttonText: "See What's Available",
    buttonLink: '/listings',
  },
  {
    // Add e.g. `import mountainsImg from '../../../../assets/mountains.png'` when the file exists.
    icon: mapIcon,
    title: 'Get Outside',
    description: 'Pick up your gear and go. Adventure without the cost or clutter.',
    buttonText: 'Start Exploring',
    buttonLink: '/listings',
  },
];

const Cta = props => {
  const { sectionId, className, rootClassName, defaultClasses, appearance, options } = props;

  return (
    <SectionContainer
      id={sectionId}
      className="cta-section"
      rootClassName={classNames(rootClassName || css.root)}
      appearance={appearance}
      contentClassName={css.CtaContent}
      options={options}
    >
      <div className={css.inner}>
        {content.map((item, index) => (
          <React.Fragment key={index}>
            <div key={index} className={css.item}>
              <div className={css.icon}>
                <img src={item.icon} alt={item.title} />
              </div>
              <div className={css.content}>
                <h3 className={css.title}>{item.title}</h3>
                <p className={css.description}>{item.description}</p>
              </div>
              {/* <div className={css.button}>
                <a href={item.buttonLink}>{item.buttonText}</a>
              </div> */}
            </div>
          </React.Fragment>
        ))}
      </div>
    </SectionContainer>
  );
};

export default Cta;
